import $ from "jquery";

const eventTabClick = () => {
  const init = () => {
    $(document).ready(function () {
      exec();
    });
  };
  const exec = () => {
    const transitionTime = 250;
    $(".btn-tab-product.trade").on("click", function () {
      setTimeout(() => {
        $(".inner-sec-title__trade").fadeIn(transitionTime);
      }, transitionTime - 10);
      $(".inner-sec-title__test").fadeOut(transitionTime);

      $(".btn-tab-product.trade").addClass("active");
      $(".btn-tab-product.test").removeClass("active");
    });

    $(".btn-tab-product.test").on("click", function () {
      $(".inner-sec-title__trade").fadeOut(transitionTime);
      setTimeout(() => {
        $(".inner-sec-title__test").fadeIn(transitionTime);
      }, transitionTime - 10);
      $(".btn-tab-product.trade").removeClass("active");
      $(".btn-tab-product.test").addClass("active");
    });
  };
  init();
};

try {
  eventTabClick();
} catch (e) {
  console.error(e);
}
